module.exports = __webpack_public_path__ + "img/carrot.be5030ca.webp";